import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useMediaQuery,
} from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { Can } from "@src/utils/components/permissions";
import cs from "classnames";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";

interface ActionsProps {
  size: "md" | "sm";

  isClosed: boolean;
  isLocked: boolean;

  onOpen: () => void;
  openLoading?: boolean;

  onClose: () => void;
  closeLoading?: boolean;

  onLock: () => void;
  lockLoading?: boolean;

  onUnlock: () => void;
  unlockLoading?: boolean;
}

const Actions = (props: ActionsProps) => {
  const [isLargerThan1500] = useMediaQuery("(min-width: 1500px)");

  const label = useMemo(() => {
    if (props.size === "md") {
      return {
        open: t`Open month`,
        close: t`Close month`,
        lock: t`Lock month`,
        unlock: t`Unlock month`,
      };
    }
    return {
      open: t`Open`,
      close: t`Close`,
      lock: t`Lock`,
      unlock: t`Unlock`,
    };
  }, [props.size]);

  return (
    <div
      className={cs(
        "flex justify-end",
        props.size === "md" ? "space-x-4" : "space-x-2",
      )}
    >
      {props.size === "sm" && !isLargerThan1500 ? (
        <Menu>
          <MenuButton>
            <Icon color="#02929d" name="dots-horizontal" />
          </MenuButton>

          <MenuList>
            {props.isLocked ? (
              <React.Fragment>
                {props.isLocked ? (
                  <Can
                    do={["wip_unlock_own", "wip_unlock_team", "wip_unlock_all"]}
                  >
                    <MenuItem onClick={props.onUnlock}>
                      {" "}
                      {label.unlock}
                    </MenuItem>
                  </Can>
                ) : (
                  <React.Fragment>
                    <Can do={["wip_open_own", "wip_open_team", "wip_open_all"]}>
                      <MenuItem onClick={props.onOpen}>{label.open}</MenuItem>
                    </Can>
                    <Can do={["wip_lock_own", "wip_lock_team", "wip_lock_all"]}>
                      <MenuItem onClick={props.onLock}>{label.lock}</MenuItem>
                    </Can>
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : (
              <Can do={["wip_close_own", "wip_close_team", "wip_close_all"]}>
                <MenuItem onClick={props.onClose}>{label.close}</MenuItem>
              </Can>
            )}
          </MenuList>
        </Menu>
      ) : props.isClosed ? (
        <React.Fragment>
          {props.isLocked ? (
            <Can do={["wip_unlock_own", "wip_unlock_team", "wip_unlock_all"]}>
              <Button
                isLoading={props.unlockLoading}
                onClick={props.onUnlock}
                size={props.size}
              >
                {label.unlock}
              </Button>
            </Can>
          ) : (
            <React.Fragment>
              <Can do={["wip_open_own", "wip_open_team", "wip_open_all"]}>
                <Button
                  isLoading={props.openLoading}
                  onClick={props.onOpen}
                  size={props.size}
                >
                  {label.open}
                </Button>
              </Can>
              <Can do={["wip_lock_own", "wip_lock_team", "wip_lock_all"]}>
                <Button
                  isLoading={props.lockLoading}
                  onClick={props.onLock}
                  size={props.size}
                >
                  {label.lock}
                </Button>
              </Can>
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <Can do={["wip_close_own", "wip_close_team", "wip_close_all"]}>
          <Button
            isLoading={props.closeLoading}
            onClick={props.onClose}
            size={props.size}
          >
            {label.close}
          </Button>
        </Can>
      )}
    </div>
  );
};

export default observer(Actions);
